import {asset} from 'imba';
import url from './terminal.svg';
export default asset({
	url: url,
	type: 'svg',
	meta: {"attributes":{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"},"flags":["feather","feather-terminal"],"content":"<polyline points=\"4 17 10 11 4 5\"></polyline><line x1=\"12\" y1=\"19\" x2=\"20\" y2=\"19\"></line>"},
	toString: function(){ return this.url;}
})